import { useMemo, useState } from 'react';
import { useAppScopeStore, useOnScopeChange } from '@frontend/scope';

export const useLocationFilterMenu = (preselectedAccessibleLocationIds: string[]) => {
  const { getScopeName } = useAppScopeStore();

  const [filteredLocationIds, setFilteredLocationIds] = useState<string[]>(preselectedAccessibleLocationIds);

  useOnScopeChange((newIds) => {
    setFilteredLocationIds(newIds ?? []);
  });

  const locationOptions = useMemo(
    () =>
      preselectedAccessibleLocationIds.map((id) => ({
        label: getScopeName(id),
        value: id,
      })),
    [getScopeName, preselectedAccessibleLocationIds]
  );

  return { onChange: setFilteredLocationIds, selectedOptions: filteredLocationIds, options: locationOptions };
};
